module.exports = __webpack_public_path__ + "static/stocksnap_vdovpj7hfk-386f8a2bad89c9d03d1558d171b1fb61.jpg";